import { IconButton, type IconButtonProps } from '@mui/material';
import { forwardRef } from 'react';

/**
 * @tier atom
 *
 * Icon-only button. Inherits all interactive styling from the design system theme.
 *
 * Wrap an `Icon` (from foundations/icons) as the only child. The icon will pick
 * up the surrounding `color` token via `currentColor`.
 *
 * Use `aria-label` on every instance — MUI requires it for accessibility.
 */
export type VyIconButtonProps = IconButtonProps;

export const VyIconButton = forwardRef<HTMLButtonElement, VyIconButtonProps>(
  function VyIconButton(props, ref) {
    return <IconButton ref={ref} {...props} />;
  },
);
